import enableCaptchaFunctionality from 'Common/captcha';
import enableValidationFunctionality from './validation';
/**
 * Enables the forms functionality.
 */
const enableFormsFunctionality = () => {
    enableCaptchaFunctionality();
    enableValidationFunctionality();
};
export default enableFormsFunctionality;
